import { initialCheckoutSessionTokenState, CHECKOUT_SESSION_TOKEN_ACTIONS } from './checkoutSessionToken.types'

/**
 * @param {import('./checkoutSessionToken.types').CheckoutSessionTokenSlice} state
 * @param {import('./checkoutSessionToken.types').CheckoutSessionTokenAction} action
 * @returns {import('./checkoutSessionToken.types').CheckoutSessionTokenSlice}
 */
export function checkoutSessionTokenReducer(state = initialCheckoutSessionTokenState, { type, payload }) {
  switch (type) {
    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_TOKEN:
      return { ...state, token: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SHORT_CODE:
      return { ...state, shortCode: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_MULTI_ADDRESS_SELECTION:
      return { ...state, multiAddressSelection: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SELECTED_BILLING_ADDRESS:
      return { ...state, selectedBillingAddress: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_SELECTED_CUSTOMER_ADDRESS_ID:
      return { ...state, selectedCustomerAddressId: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_GUEST_CHECKOUT_DATA:
      return { ...state, guestCheckoutData: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_PAYMENT_STATUS:
      return { ...state, paymentStatus: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_USED:
      return { ...state, used: payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.SET_TOKEN_DATA:
      return { ...state, ...payload }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    case CHECKOUT_SESSION_TOKEN_ACTIONS.CLEAR_TOKEN:
      return { ...initialCheckoutSessionTokenState }

    default:
      return state
  }
}
